import React from "react";
import { bool } from "prop-types";

import AdvertiseDropdown from "./AdvertiseDropdown";
import AdvertiseLink from "./AdvertiseLink";

const Advertise = props => {
  const { has_advertise_dropdown, has_advertise_link } = props;

  if (has_advertise_dropdown) {
    return <AdvertiseDropdown {...props} />;
  } else if (has_advertise_link) {
    return <AdvertiseLink {...props} />;
  }
  return null;
};

Advertise.propTypes = {
  has_advertise_dropdown: bool,
  has_advertise_link: bool
};
Advertise.defaultProps = {
  has_advertise_dropdown: false,
  has_advertise_link: false
};

export default Advertise;
